import { render, staticRenderFns } from "./bought.vue?vue&type=template&id=8cc76a42&scoped=true&"
import script from "./bought.vue?vue&type=script&lang=js&"
export * from "./bought.vue?vue&type=script&lang=js&"
import style0 from "./bought.vue?vue&type=style&index=0&id=8cc76a42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc76a42",
  null
  
)

export default component.exports